import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { CleanIcon, DownloadIcon, ThemeIcon, SettingIcon, CodeIcon } from '../icons';
import { ThemeView } from './Themes';
import { DownloadView } from './Download';
import { LanguageView } from './Language';
import { SettingView } from './Setting';
import { Context } from '../../store/content';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Warpper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  gap: 1rem;\n  z-index: 9;\n"])));
export var Button = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n  width: 2.1rem;\n  height: 2.1rem;\n  border-radius: 0.5rem;\n  border: 0;\n  transition: all 0.3s;\n  background: var(--color-ci-btn-bg);\n  color: currentColor;\n  svg {\n    height: 1.8em;\n  }\n  &:hover {\n    background-color: var(--color-ci-btn-hover-bg);\n    color: currentColor;\n  }\n  &:active {\n    background-color: var(--color-ci-btn-bg);\n    color: currentColor;\n  }\n  ", "\n"])), props => props.active && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      background-color: var(--color-ci-btn-hover-bg);\n      color: currentColor;\n    "]))));
export var BlockButton = styled(Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  width: initial;\n  border-radius: 0.3rem;\n  justify-content: start;\n  padding-left: 0.3rem;\n  padding-right: 0.3rem;\n  gap: 0.3rem;\n"])));
var Nav = styled.nav(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.5rem 0.5rem;\n"])));
var Container = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  box-shadow: 0 0 0 1px rgb(0 0 0 / 11%), 1px 1px 5px rgb(0 0 0 / 12%);\n  border-radius: 0.3rem;\n  background-color: var(--color-ci-bg);\n"])));
var Aside = styled(Container)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  overflow: auto;\n"])));
export var ToolBar = props => {
  var {
    panel,
    setPanel,
    setCode
  } = useContext(Context);
  var typeHandle = ev => {
    ev.preventDefault();
    var type = ev.currentTarget.dataset.type;
    setPanel(type === panel ? undefined : type);
  };
  var cleanCodeHandle = () => {
    setCode('');
  };
  return /*#__PURE__*/_jsxs(Warpper, _extends({}, props, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Nav, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-type": "clean",
          active: panel === 'clean',
          onClick: cleanCodeHandle,
          children: /*#__PURE__*/_jsx(CleanIcon, {})
        }), /*#__PURE__*/_jsx(Button, {
          "data-type": "download",
          active: panel === 'download',
          onClick: typeHandle,
          children: /*#__PURE__*/_jsx(DownloadIcon, {})
        }), /*#__PURE__*/_jsx(Button, {
          "data-type": "style",
          active: panel === 'style',
          onClick: typeHandle,
          children: /*#__PURE__*/_jsx(ThemeIcon, {})
        }), /*#__PURE__*/_jsx(Button, {
          "data-type": "lang",
          active: panel === 'lang',
          onClick: typeHandle,
          children: /*#__PURE__*/_jsx(CodeIcon, {})
        }), /*#__PURE__*/_jsx(Button, {
          "data-type": "setting",
          active: panel === 'setting',
          onClick: typeHandle,
          children: /*#__PURE__*/_jsx(SettingIcon, {})
        })]
      })
    }), panel === 'style' && /*#__PURE__*/_jsx(Aside, {
      children: /*#__PURE__*/_jsx(ThemeView, {})
    }), panel === 'download' && /*#__PURE__*/_jsx(Aside, {
      children: /*#__PURE__*/_jsx(DownloadView, {})
    }), panel === 'lang' && /*#__PURE__*/_jsx(Aside, {
      children: /*#__PURE__*/_jsx(LanguageView, {})
    }), panel === 'setting' && /*#__PURE__*/_jsx(Aside, {
      children: /*#__PURE__*/_jsx(SettingView, {})
    })]
  }));
};